// extracted by mini-css-extract-plugin
export var cardGroup = "CardGroup-module--cardGroup--KjP87";
export var cdsAssistiveText = "CardGroup-module--cds--assistive-text--yoHGx";
export var cdsVisuallyHidden = "CardGroup-module--cds--visually-hidden--KU2NU";
export var hideFeedback = "CardGroup-module--hide-feedback--PHWIe";
export var showFeedback = "CardGroup-module--show-feedback--1Jl68";
export var skeleton = "CardGroup-module--skeleton--1AKPK";